import {
    IressButton,
    IressInline,
    IressModal,
    IressSkeleton,
    IressStack,
    IressText,
    useModal,
} from '@iress-oss/ids-components';
import { FC, RefObject } from 'react';
import { Nullable, Scenario } from '@xplan-pension-switching/common';
import { useSearchParams } from 'react-router';
import { useScenarioQuery, useScenarioQueryInvalidation } from '../../services';

export const DeleteScenarioModal: FC<{ container?: RefObject<Nullable<HTMLDivElement>> }> = ({ container }) => {
    const { showModal } = useModal();
    const [urlParams, setUrlParams] = useSearchParams();
    const scenarioId = urlParams.get('deleteScenarioId');
    const entityId = urlParams.get('entityid');
    const { data } = useScenarioQuery(Number(entityId), Number(scenarioId));
    const invalidateQueries = useScenarioQueryInvalidation(Number(entityId));
    return (
        <IressModal
            container={container}
            id="delete-scenario-modal"
            data-testid="delete-scenario-modal"
            heading="Delete Scenario"
            size="sm"
            onExited={() => {
                urlParams.delete('deleteScenarioId');
                setUrlParams(urlParams);
            }}
            footer={
                <IressInline gutter="sm" horizontalAlign="right">
                    <IressButton
                        mode="secondary"
                        data-testid="delete-scenario-cancel"
                        onClick={() => {
                            showModal('delete-scenario-modal', false);
                        }}
                    >
                        Cancel
                    </IressButton>
                    <IressButton
                        mode="primary"
                        data-testid="delete-scenario-delete"
                        onClick={() => {
                            showModal('delete-scenario-modal', false);
                            invalidateQueries();
                        }}
                    >
                        Delete
                    </IressButton>
                </IressInline>
            }
        >
            {(data as Scenario | undefined)?.scenarioName ? (
                <IressText>
                    Are you sure you want to delete {(data as Scenario | undefined)?.scenarioName} scenario?
                </IressText>
            ) : (
                <IressStack>
                    <IressSkeleton
                        mode="text"
                        textVariant="display4"
                        width="25%"
                        data-testid="entity-details-loader__heading"
                    />
                </IressStack>
            )}
        </IressModal>
    );
};
